import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferSection() {
  return <section id="offer-section" className="py-20 bg-gradient-to-b from-white to-[#e8f4fc]" data-id="element-65">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-67">
          <div className="bg-[#1e4d7b] p-6 text-center" data-id="element-68">
            <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-69">
              Llévate el pack completo por un precio especial
            </h2>
          </div>

          <div className="p-8 md:p-12" data-id="element-70">
            <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-10" data-id="element-71">
              <div className="space-y-4 w-full md:w-1/2" data-id="element-72">
                <div className="flex justify-between items-center text-gray-500 line-through" data-id="element-73">
                  <span data-id="element-74">Presentación rápida</span>
                  <span data-id="element-75">10€</span>
                </div>
                <div className="flex justify-between items-center text-gray-500 line-through" data-id="element-76">
                  <span data-id="element-77">E-book Hogar Blindado</span>
                  <span data-id="element-78">15€</span>
                </div>
                <div className="flex justify-between items-center text-gray-500 line-through" data-id="element-79">
                  <span data-id="element-80">Audiolibro</span>
                  <span data-id="element-81">12€</span>
                </div>
                <div className="h-px bg-gray-200 my-4" data-id="element-82"></div>
                <div className="flex justify-between items-center text-xl text-gray-400 font-bold line-through" data-id="element-83">
                  <span data-id="element-84">Precio Normal</span>
                  <span data-id="element-85">37€</span>
                </div>
              </div>

              <div className="w-full md:w-1/2 bg-[#e8f4fc] rounded-2xl p-6 text-center border-2 border-[#4a90c2]" data-id="element-86">
                <p className="text-[#1e4d7b] font-medium mb-2" data-id="element-87">
                  OFERTA LIMITADA
                </p>
                <p className="text-sm text-gray-600 mb-4" data-id="element-88">
                  Hoy todo el pack por solo
                </p>
                <div className="text-5xl font-bold text-[#1e4d7b] mb-2" data-id="element-89">
                  6,50€
                </div>
                <p className="text-xs text-gray-500" data-id="element-90">
                  Pago único • Acceso de por vida
                </p>
              </div>
            </div>

            <div className="text-center space-y-6" data-id="element-91">
              <motion.a href="https://go.hotmart.com/M104264502J?dp=1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full md:w-auto px-10 py-5 bg-[#1e4d7b] hover:bg-[#163a5e] text-white font-bold text-xl rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3 mx-auto" data-id="element-92">
                Quiero acceso a Hogar Blindado
                <ArrowRight className="h-6 w-6" data-id="element-93" />
              </motion.a>

              <div className="flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-94">
                <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-95" />
                <span data-id="element-96">Garantía de satisfacción</span>
                <span className="mx-2" data-id="element-97">•</span>
                <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-98" />
                <span data-id="element-99">Pago seguro</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}